enum SidebarNavigationItemTypesEnum {
  revenues = 'revenues',
  clients = 'clients',
  taxes = 'taxes',
  expenses = 'expenses',
  banks = 'banks',
  export = 'export',
  primary = 'primary',
  help = 'help',
  more = 'more',
  yearlyReview = 'yearlyReview',
  support = 'support',
  peppol = 'peppol',
  AI = 'AI',
}

enum SidebarNavigationItemTextStyles {
  revenues = 'text-revenues-900',
  expenses = 'text-expenses-900',
  banks = 'text-bank-900',
  taxes = 'text-taxes-900',
  clients = 'text-revenues-900',
  export = 'text-primary-700',
  AI = 'text-taxes',
  primary = 'text-primary-900',
  help = 'text-primary-900',
  yearlyReview = 'text-white',
  more = 'text-primary-900',
  support = 'text-primary-900',
  peppol = 'text-white',
}

enum SideBarNavigationItemIconStyles {
  revenues = 'text-revenues-900',
  expenses = 'text-expenses-900',
  banks = 'text-bank-900',
  taxes = 'text-taxes-900',
  clients = 'text-revenues-900',
  export = 'text-primary-900',
  AI = 'text-taxes-900',
  help = 'text-primary-900',
  primary = 'text-primary-900',
  yearlyReview = 'text-white',
  more = 'text-primary-900',
  support = 'text-primary-900',
  peppol = 'text-white',
}

enum SidebarNavigationItemBGStyles {
  revenues = '!text-revenues-900 group-hover:bg-revenues-100',
  expenses = '!text-expenses-900 group-hover:bg-expenses-100',
  banks = '!text-bank-900 group-hover:bg-bank-100',
  taxes = 'text-taxes-900 group-hover:bg-taxes-100',
  clients = '!text-revenues-900 group-hover:bg-revenues-100',
  export = '!text-primary-900 group-hover:bg-primary-100',
  AI = '!text-primary-900 group-hover:bg-primary-100',
  primary = '!text-primary-900 group-hover:bg-primary-100',
  help = '!text-primary-900 group-hover:bg-primary-100',
  more = '!text-primary-900 group-hover:bg-primary-100',
  support = '!text-primary-900 group-hover:bg-primary-100',
  yearlyReview = '!bg-taxes-500 bg-snow group-hover:!bg-taxes-600',
  peppol = 'bg-taxes',
}

enum SidebarNavigationItemSelectedBGStyles {
  revenues = 'bg-revenues-100',
  expenses = 'bg-expenses-100',
  banks = 'bg-bank-100',
  taxes = 'bg-taxes-100',
  clients = 'bg-revenues-100',
  export = 'bg-primary-100',
  AI = 'bg-primary-100',
  primary = 'bg-primary-100',
  help = 'bg-primary-100',
  more = 'bg-primary-100',
  yearlyReview = '!bg-taxes-800 bg-snow',
  support = 'bg-primary-100',
  peppol = 'bg-primary',
}

enum SidebarNavigationItemDefaultTextStyles {
  revenues = 'group-hover:!text-revenues-900',
  expenses = 'group-hover:!text-expenses-900',
  banks = 'group-hover:!text-bank-900',
  taxes = 'group-hover:!text-taxes-900',
  clients = 'group-hover:!text-revenues-900',
  export = 'group-hover:!text-primary-900',
  AI = 'group-hover:!text-taxes-900',
  help = 'group-hover:!text-primary-900',
  primary = 'group-hover:!text-primary-900',
  more = 'group-hover:!text-primary-900',
  support = 'group-hover:!text-primary-900',
  yearlyReview = 'text-white',
  peppol = 'text-white',
}

export {
  SidebarNavigationItemTypesEnum,
  SidebarNavigationItemTextStyles,
  SidebarNavigationItemBGStyles,
  SideBarNavigationItemIconStyles,
  SidebarNavigationItemSelectedBGStyles,
  SidebarNavigationItemDefaultTextStyles,
};
